import { createStyles, makeStyles, Theme } from '@material-ui/core';

const ModalGlobalStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      display: 'block',
      position: 'fixed',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      background: 'hsla(var(--gris-l3-h), var(--gris-l3-s), var(--gris-l3-l), 0.7)',
      transition: 'var(--transition) opacity',
      zIndex: 40,
      [theme.breakpoints.down('sm')]: {
        zIndex: 40,
      },
    },
    modalGlobal: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      background: 'var(--blanco)',
      padding: '44px',
      borderRadius: '15px',
      boxShadow: 'var(--box-shadow)',
      transform: 'translate(-50%, -50%)',
      zIndex: 40,
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        width: '90%',
        padding: '44px 20px 44px 20px',
      },
    },
    contenedorGlobal: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '0px',
      gap: '24px',
      flex: 'none',
      order: 0,
      alignSelf: 'stretch',
      flexGrow: 0,
      zIndex: 0,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },

    tituloTextos: {
      fontFamily: 'Neutrif Studio',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '20px',
      textAlign: 'center',
      color: 'var(--secundario-azul-marino)',
      flex: 'none',
      order: 0,
      flexGrow: 0,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },

    parrafoGlobal: {
      textAlign: 'center',
      fontFamily: 'Neutrif Studio',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: 'var(--gris-l3)',
      flex: 'none',
      alignSelf: 'stretch',
      flexGrow: 0,

      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },

    contenedorCerrar: {
      position: 'fixed',
      top: 0,
      right: 0,
      padding: '18px',
    },

    contenedorTitulo: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },

    boton: {
      width: '106px',
      fontSize: '14px',
      padding: '14px 32px 13px 32px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },

    contenedorBotones: {
      marginTop: '20px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'flex-start',
      padding: '0px',
      gap: '16px',
      width: '100%',
      height: '45px',
      flex: 'none',
      order: 1,
      flexGrow: 0,
      zIndex: 1,
      [theme.breakpoints.down('sm')]: {
        maxWidth: '100%',
      },
    },

    parrafosConLinks: {
      fontFamily: 'Neutrif Studio',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: 'var(--gris-l3)',
    },
    textoLink: {
      fontSize: '14px',
      fontFamily: 'Neutrif Studio',
      fontStyle: 'normal',
      fontWeight: 600,
      lineHeight: '18px',
      color: 'var(--primario-morado)',
      textDecoration: 'none',
      cursor: 'pointer',
      userSelect: 'none',
      '&:hover': {
        color: '#2700B8',
      },
      [theme.breakpoints.down('sm')]: {
        display: 'inline',
      },
    },
    contenedorIcono: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: '14px',
    },
    botonCerrar: {
      padding: '0px',
    },
  })
);

export default ModalGlobalStyles;
